import { useEffect, useMemo, useState } from "react";

import { useParams } from "react-router-dom";

import useSocialSchedules from "../../data/useSocialSchedules";
import { ButtonInput } from "../Shared/Inputs/ButtonInput";
import ScheduleRowBox from "./ScheduleRowBox";
import { createReverseLookup, socialTriggerType } from "../../constants/enums";
import AddEditScheduleModal from "./AddEditScheduleModal";

export default function ScheduleManager({ triggerTypeName }) {
  const { agencyId, pageId } = useParams();
  const { socialSchedules, add, update, remove } = useSocialSchedules(agencyId);
  const [schedules, setSchedules] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [addEditScheduleOpen, setAddEditScheduleOpen] = useState(false);

  const reverseLookup = createReverseLookup(socialTriggerType);

  const triggerTypeEnumValue = useMemo(() => {
    return reverseLookup[triggerTypeName];
  }, [reverseLookup, triggerTypeName]);

  useEffect(() => {
    if (!socialSchedules.isLoading && socialSchedules.data) {
      setSchedules(
        socialSchedules.data
          .filter((s) => s.trigger.triggerType == triggerTypeEnumValue)
          .filter((s) => s.name !== "Manual Post")
      );
      setIsLoading(false);
    }
  }, [
    socialSchedules.data,
    socialSchedules.isLoading,
    triggerTypeEnumValue,
    triggerTypeName,
  ]);

  return (
    <>
      <AddEditScheduleModal
        open={addEditScheduleOpen}
        setOpen={setAddEditScheduleOpen}
        defaultTriggerType={triggerTypeName}
      />
      <div className="flex flex-col gap-y-4">
        <div className="flex justify-between items-center">
          <h1 className="text-lg font-semibold">{triggerTypeName} Manager</h1>
          {/* triggerTypeEnumValue != reverseLookup["News"] || (triggerTypeEnumValue == reverseLookup["News"] && schedules?.length === 0) && ( */}
          <ButtonInput
            label="Add New Schedule"
            isSubmit={false}
            onClick={() => setAddEditScheduleOpen(true)}
          />
        </div>

        <div>
          {!isLoading && schedules && schedules.length > 0 ? (
            <div className="grid grid-cols-2 gap-4">
              {schedules.map((schedule) => (
                <ScheduleRowBox
                  key={schedule.id}
                  scheduleId={schedule.id}
                  triggerType={triggerTypeName}
                />
              ))}
            </div>
          ) : (
            <div>No {triggerTypeName} Schedules found</div>
          )}
        </div>
      </div>
    </>
  );
}
